import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9870ec76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-2 col-sm-1 col-xs-1" }, null, -1))
const _hoisted_3 = { class: "col-lg-4 col-md-8 col-sm-10 col-xs-10 mt-4" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "m-5" }, " La página que busca no existe ", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4 col-md-2 col-sm-1 col-xs-1" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("img", { src: _ctx.img404 }, null, 8, _hoisted_4),
      _hoisted_5,
      _createVNode(_component_q_btn, {
        outline: "",
        color: "indigo-10",
        label: "Volver a la página principal",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:'login'})))
      })
    ]),
    _hoisted_6
  ]))
}